<div class="flex items-center justify-between">
  <div class="z-20 relative">
    <p-button
      label="{{'animalDocuments.multiSelection' | transloco}}"
      icon="pi pi-check-square"
      styleClass="p-button-outlined"
      (click)="onToggleMultiSelectMode()"
      [disabled]="documents.length <= 1 || isMultiSelectMode"
    />
  </div>
  <app-document-upload
    [animal]="animal"
    (documentsUploaded)="documentsUploaded.emit($event)"
    class="right-0"
  />
</div>
<p-fieldset legend="Filter" class="flex-1 relative z-20">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-col gap-3">
      <span class="uppercase text-sm font-semibold text-gray-500">
        {{ 'animalDocuments.filter.source.headline' | transloco }}
      </span>
      <div class="flex flex-wrap gap-4">
        <div class="flex gap-2">
          <p-checkbox
            [(ngModel)]="filter.showUpload"
            inputId="showUpload"
            binary="true"
            (ngModelChange)="filterChange.emit()"
          />
          <label for="showUpload" class="text-sm">
            {{ 'animalDocuments.filter.source.upload' | transloco }}
          </label>
        </div>
        <div class="flex gap-2">
          <p-checkbox
            [(ngModel)]="filter.showGenerated"
            inputId="showGenerated"
            binary="true"
            (ngModelChange)="filterChange.emit()"
          />
          <label for="showGenerated" class="text-sm">
            {{ 'animalDocuments.filter.source.generated' | transloco }}
          </label>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <span class="uppercase text-sm font-semibold text-gray-500">{{ 'animalDocuments.labels.category' | transloco }}</span>
      <div class="flex flex-wrap gap-2">
        @for (cat of categoryOptions; track cat.value) {
          <p-chip
            class="cursor-pointer"
            [label]="('animal.documentCategory.' + cat.value) | transloco"
            [removable]="false"
            [ngClass]="{
              'bg-primary text-white': isSelectedCategory(cat.value),
              'bg-gray-200 text-gray-800': !isSelectedCategory(cat.value)
            }"
            (click)="toggleCategoryFromString(cat.value)"
          ></p-chip>
        }
      </div>
    </div>
  </div>
</p-fieldset>
